import * as React from 'react'

import Radio from '../Radio'

interface TableCheckboxProps {
  checked: boolean
  onClick: () => void
  disabled: boolean
  background?: boolean
  isHovered?: boolean
}

const TableRadio = ({
  checked,
  onClick,
  disabled,
  background = false,
  isHovered = false,
}: TableCheckboxProps) => {
  return (
    <th
      onClick={(e) => e.stopPropagation()}
      className={`notches-border--left tw-relative tw-w-4 tw-pb-1.5 tw-pl-2 tw-pr-2 tw-pt-2.5 ${isHovered && 'tw-bg-white/0'} ${!background && 'lg:tw-bg-white/0'} ${checked && background ? '' : 'tw-bg-white '}`}
    >
      <label className={`tw-inline-flex tw-items-center`}>
        <Radio onClick={() => onClick()} disabled={disabled} checked={checked} />
      </label>
    </th>
  )
}

export default TableRadio
